export const pagesPaths = {
    home: '/home',
    proxy: '/proxy',
    myRequests: '/my-requests',
    resources: '/resources',
    admin: '/admin',
} as const;

export type PagesPathsKeys = keyof typeof pagesPaths;
